export default __webpack_public_path__ + "static/media/payment-screen-enhanced.0ec1dc29.png";